export const PICTOGRAM_CATEGORIES = {
    picFile: {
        官方资料: 'Official data',
        资料专区管理: 'Data management',
        需求: 'Demand',
        介绍: 'Introduction',
        知识头条: 'Knowledge headlines',
        上架申请: 'Launch application',
        三方申请: 'third-party-application',
        法务合规申请: 'Legal compliance application',
        功能录入: 'Function registration',
        流程: 'Process',
        体验: 'Experience',
        社区管理: 'Community management',
        '产品版本-文档': 'product-version--documentation',
        立项申请: 'product-set-up-application',
        报价: 'Offer',
        公测发布: 'Public beta release',
        公测: 'public-beta',
        产品立项: 'product-set-up',
        文件夹: 'Folder'
    },
    picManagement: {
        规划1: 'Planning1',
        产品上市管理: 'Product launch management',
        版本管理: 'Version management',
        客户管理: 'Customer management',
        功能管理: 'Function management',
        需求管理: 'Demand management',
        规格管理: 'Instance management',
        '规格族-多支管理': 'instance-family--multi-branch-management',
        '规格族-同步管理': 'instance-family--synchronization-management',
        产品绩效管理: 'Product performance management',
        企业管理: 'Business management',
        功能支持: 'Function support',
        开发: 'development'
    },
    picTechnology: {
        云产品: 'Cloud product',
        基础: 'Basis',
        三方产品信息: 'third-party-product',
        专有云信息: 'proprietary-cloud',
        '规格族-SPU': 'instance-family--spu',
        '规格族-版本规划': 'instance-family--version-planning',
        IP供给员: 'IP provider',
        专线接入: 'dedicated-connect',
        商家配置: 'Merchant configuration',
        官网导航: 'Website navigation',
        生命周期: 'life-cycle',
        备份: 'Backups',
        服务: 'Service',
        源代码批露: 'Source code disclosure',
        开发和公测: 'Development and public beta',
        国际站整体运营: 'international-site--overall-operation'
    },
    picCloud: {
        公共云功能变更: 'public-cloud--function-change',
        线下输出: 'Offline output',
        公共云功能变更2: 'public-cloud--function-change2',
        专有云功能变更申请: 'proprietary-cloud--function-change-application',
        专有云退市申请: 'proprietary-cloud--takedown-application2',
        专有云功能配套: 'proprietary-cloud--function-package',
        专有云调价: 'proprietary-cloud--price-adjustment',
        专有云退市申请2: 'proprietary-cloud--takedown-application2',
        变更配置: 'configuration-change',
        下线申请: 'Offline application',
        下线配置: 'Offline configuration'
    },
    picProduct: {
        公共云产品调价: 'public-cloud-product--price-adjustment',
        产品名称变更: 'Product name change1',
        国际站产品流量: 'international-site--product-traffic',
        产品经营分析: 'Product business analysis',
        产商品信息: 'Product information',
        产品管理分析: 'Product management analysis',
        产品管理规范: 'Product management specification',
        产品部署: 'Product deployment',
        产品增长: 'Product growth',
        '产品版本-规划': 'product-version--planning',
        '产品版本-同步': 'product-version--synchronize',
        '产品版本-部署同步': 'product-version--deployment-synchronization',
        '产品版本-发布': 'product-version--release',
        产品: 'Product',
        产品名称变更2: 'Product name change',
        产品映射关系变更: 'Product mapping change',
        产品间收入调整: 'revenue-adjustment-between-products',
        产品间非固定比例分成: 'revenue-share-between-products-by-a-non-fixed-proportion',
        产品间固定比例分成: 'revenue-share-between-products-by-a-fixed-proportion',
        产品间非固定比例双算: 'double-calculation-between-products-by-a-non-fixed-proportion',
        产品间固定比例双算: 'double-calculation-between-products-by-a-fixed-proportion',
        PD变更: 'Change PD',
        '功能族-版本发布': 'function-family--version-release'
    },
    picAnalytics: {
        营销: 'Marketing',
        '数据对比-竞品': 'Data comparison--competitor',
        '数据对比-选型': 'Data comparison--selection',
        '数据对比-演进': 'Data comparison--evolution',
        '数据对比-回溯': 'Data comparison--backtracking',
        '数据对比-地域': 'Data comparison--area',
        产品经营数据: 'Product business data',
        国际经营分析: 'International business analysis',
        运营分析: 'Operation analysis',
        流程指标: 'Process indicators',
        客户指标: 'Customer indicators',
        产品体验看板: 'Product dashboard',
        业绩收入指标: 'performance-revenue-indicators',
        Gaap收入指标: 'gaap-revenue-indicators',
        线下项目指标: 'Offline project indicators'
    },
    picCommercialTrade: {
        竞对管理: 'competitor-management',
        商业洞察: 'Business insight',
        上市计划: 'Launch plan',
        商业化: 'commercialization',
        互联网: 'Internet',
        用户集市: 'user-pool',
        现金收入指标: 'performance-revenue-indicators',
        商业贸易: 'Commercial trade',
        商业化2: 'Commercialize',
        市场洞察: 'Market insight',
        运营: 'marketing',
        竞标: 'Bidding',
        受影响资产: 'Affected assets',
        经营: 'Operating'
    },
    picProcess: {
        设计: 'Design',
        规划2: 'Planning2',
        策略确认: 'Strategy confirmation',
        变更: 'Change',
        体系改进: 'System improvement',
        运营资源申请: 'Operation resource application',
        解决方案: 'Solution',
        分配: 'Distribution',
        邀测验证: 'beta-invitation-verification',
        线下: 'Offline'
    },
    picOther: { 头条: 'Headlines', 官方资料: 'Official documentation', 危险情报: 'alerting-information' },
    filled: {
        accordion: 'https://img.alicdn.com/imgextra/i4/O1CN019Ww5Sr1LtYE8Pm9EY_!!6000000001357-55-tps-48-48.svg',
        category: 'https://img.alicdn.com/imgextra/i1/O1CN01AVCbz91snUIyWbtZq_!!6000000005811-55-tps-48-48.svg',
        button: 'https://img.alicdn.com/imgextra/i4/O1CN01qKDfUN27MCx5voMcY_!!6000000007782-55-tps-48-48.svg',
        'basic-container': 'https://img.alicdn.com/imgextra/i2/O1CN018X3OLJ29coXcHFws7_!!6000000008089-55-tps-48-48.svg',
        action: 'https://img.alicdn.com/imgextra/i4/O1CN01GPZuho1tPxZnKuDCh_!!6000000005895-55-tps-48-48.svg',
        form: 'https://img.alicdn.com/imgextra/i2/O1CN01iDLpY31UmWh8NYiwx_!!6000000002560-55-tps-48-48.svg',
        'grid-layout': 'https://img.alicdn.com/imgextra/i3/O1CN01GulcrJ1XJcXxOg9SZ_!!6000000002903-55-tps-48-48.svg',
        modal: 'https://img.alicdn.com/imgextra/i1/O1CN01IdXLY61eLBCosEtGM_!!6000000003854-55-tps-48-48.svg',
        checkbox: 'https://img.alicdn.com/imgextra/i4/O1CN013HVeup27xJ25imabF_!!6000000007863-55-tps-48-48.svg',
        'floating-button': 'https://img.alicdn.com/imgextra/i1/O1CN01cjRDj61nkfnENrx2Z_!!6000000005128-55-tps-48-48.svg',
        list: 'https://img.alicdn.com/imgextra/i3/O1CN01MqXDLT1K7dApk1ViW_!!6000000001117-55-tps-48-48.svg',
        'movable-view-container': 'https://img.alicdn.com/imgextra/i3/O1CN01rQDv4d1SlUZAj5bW1_!!6000000002287-55-tps-48-48.svg',
        'multiline-textbox': 'https://img.alicdn.com/imgextra/i2/O1CN01VwdgEw1vs14ItQHEl_!!6000000006227-55-tps-48-48.svg',
        selector: 'https://img.alicdn.com/imgextra/i1/O1CN01sMmIjw1ZnVciGmHKo_!!6000000003239-55-tps-48-48.svg',
        'scrollable-view-container': 'https://img.alicdn.com/imgextra/i1/O1CN01TIepzM1NkVdfpMw68_!!6000000001608-55-tps-48-48.svg',
        'navigation-bar': 'https://img.alicdn.com/imgextra/i2/O1CN01WH9D6P1LIuXpFkBHV_!!6000000001277-55-tps-48-48.svg',
        'picture-picker': 'https://img.alicdn.com/imgextra/i3/O1CN01rxm1mL1mpsgDhyp7c_!!6000000005004-55-tps-48-48.svg',
        'slider-view-container': 'https://img.alicdn.com/imgextra/i2/O1CN011w785Y1a2ch6GiFT3_!!6000000003272-55-tps-48-48.svg',
        'rich-text': 'https://img.alicdn.com/imgextra/i2/O1CN01sfXklC1km6BCHBeLR_!!6000000004725-55-tps-48-48.svg',
        text: 'https://img.alicdn.com/imgextra/i3/O1CN01tIePk81HSkaWjWzeb_!!6000000000757-55-tps-48-48.svg',
        'text-input': 'https://img.alicdn.com/imgextra/i1/O1CN01GITwHl1NzciCp7cAx_!!6000000001641-55-tps-48-48.svg',
        switch: 'https://img.alicdn.com/imgextra/i4/O1CN01nmXmU429qYQSdUMFT_!!6000000008119-55-tps-48-48.svg',
        slider: 'https://img.alicdn.com/imgextra/i3/O1CN01xh063B1FGGYf36RfU_!!6000000000459-55-tps-48-48.svg',
        'tab-bar': 'https://img.alicdn.com/imgextra/i1/O1CN01VjWRVZ1T4GoHGxwXh_!!6000000002328-55-tps-48-48.svg'
    }
};
